const STORAGE_KEY = "ai_apiKey";

export function getApiKey() {
  return localStorage.getItem(STORAGE_KEY) ?? "";
}

export function setApiKey(value:string) {
  localStorage.setItem(STORAGE_KEY, value);
}
